import { reactive } from 'vue'
import { DeviceManager } from '../device'
import { DriverSocketMsg, DriverSocketMsgType } from '@libs/types/message'
import { DriverService } from './driver'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { STORAGE_KEYS } from '@libs/define/storage_key'
import { getCurrentDeviceMagnetKKs } from '@/profiles/selector'
import { KK } from '@/define/define'
import { acquireDynamicImagePause } from '@/service/image_light/dynamic_image_pause'

class _calibrationSet {
  private releaseDynamicImagePause: (() => void) | null = null
  private dynamicImagePauseDepth = 0

  state = reactive({
    initCalibrationStatus: false,
    isShowCalibrationSelect: false,
    isShowExeSingleCalibration: false,
    isShowExeAllCalibration: false,
    isShowHidCalibration: false,
  })

  // 是否是睿联微厂商的设备
  isWitmodVendor() {
    return specialCheckCurrent(speciaBehiver.DevicesOfWitmod)
  }

  initCalibration() {
    this.initializeCalibrationState()
  }

  private initializeCalibrationState() {
    this.loadCalibrationStatus()
    if (this.state.initCalibrationStatus) {
      return
    }
    this.showCalibrationPageByVendor()
  }

  // 根据厂商显示校准页面
  showCalibrationPageByVendor() {
    if (specialCheckCurrent(speciaBehiver.SupportHidCalibration)) {
      this.state.isShowHidCalibration = true
    } else if (this.isWitmodVendor()) {
      // 是否初始化校准
      if (this.state.initCalibrationStatus == false) {
        this.state.isShowExeAllCalibration = true
      } else {
        this.state.isShowCalibrationSelect = true
      }
    }
  }

  endAllKeysCalibration() {
    this.calibrationAllKeys(false).then(() => {
      this.state.isShowExeAllCalibration = false
    })
  }

  async pauseDynamicImageForCalibration() {
    this.dynamicImagePauseDepth++
    if (this.dynamicImagePauseDepth > 1) {
      return
    }

    const release = await acquireDynamicImagePause()
    if (this.dynamicImagePauseDepth > 0) {
      this.releaseDynamicImagePause = release
    } else {
      release()
    }
  }

  resumeDynamicImageAfterCalibration() {
    if (this.dynamicImagePauseDepth === 0) {
      return
    }

    this.dynamicImagePauseDepth--
    if (this.dynamicImagePauseDepth > 0) {
      return
    }

    this.releaseDynamicImagePause?.()
    this.releaseDynamicImagePause = null
  }

  private clearDynamicImagePauseForCalibration() {
    this.dynamicImagePauseDepth = 0
    this.releaseDynamicImagePause?.()
    this.releaseDynamicImagePause = null
  }

  async calibrationAllKeys(value: boolean): Promise<void> {
    if (value) {
      await this.pauseDynamicImageForCalibration()
    }

    const data = {
      Type: DriverSocketMsgType.MTMagnetCalibratin,
      Data: { Value: value },
    } as DriverSocketMsg<any>
    try {
      await DriverService.instance.askTypeAndData(data)
    } finally {
      if (!value) {
        this.resumeDynamicImageAfterCalibration()
      }
    }
  }

  markCalibrationSuccess() {
    this.updateCalibrationStatus(true)
  }

  private updateCalibrationStatus(status: boolean) {
    let data: { [pid: number]: boolean } = {}
    const resData = localStorage.getItem(STORAGE_KEYS.CALIBRATION_STATUS)
    if (resData == undefined) {
      data[DeviceManager.instance.state.currentPid] = status
      localStorage.setItem(STORAGE_KEYS.CALIBRATION_STATUS, JSON.stringify(data))
    } else {
      data = JSON.parse(resData)
      data[DeviceManager.instance.state.currentPid] = status
    }
    localStorage.setItem(STORAGE_KEYS.CALIBRATION_STATUS, JSON.stringify(data))
    this.state.initCalibrationStatus = status
  }

  private loadCalibrationStatus() {
    if (DeviceManager.instance.state.currentDevice.IsSupportMagnet == false) {
      return true
    }
    if (specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMix)) {
      this.state.initCalibrationStatus = true
      return
    }
    const status = localStorage.getItem(STORAGE_KEYS.CALIBRATION_STATUS)
    if (status == undefined) {
      this.state.initCalibrationStatus = false
    } else {
      const data: { [pid: number]: boolean } = JSON.parse(status)
      this.state.initCalibrationStatus = data[DeviceManager.instance.state.currentPid] || false
    }
    return this.state.initCalibrationStatus
  }

  async resetCalibrationStatus() {
    this.clearDynamicImagePauseForCalibration()
    this.state.initCalibrationStatus = false
    this.state.isShowHidCalibration = false
    this.state.isShowExeSingleCalibration = false
    this.state.isShowExeAllCalibration = false
    this.state.isShowCalibrationSelect = false
  }

  // 开始行程监控
  startAllKeysWatchTrave = async () => {
    await this.watchKeyTrip(getCurrentDeviceMagnetKKs.value)
  }
  // 结束行程监控
  endAllKeysWatchTrave = async () => {
    await this.watchKeyTrip([])
  }
  private watchKeyTrip(keys: KK[]) {
    const data = {
      Type: DriverSocketMsgType.MTMagnetSetWatch,
      Data: { Keys: keys },
    } as DriverSocketMsg<any>
    DriverService.instance.sendTypeAndData(data)
  }
}
const calibrationSet = new _calibrationSet()
export { calibrationSet as calibrationHandler }
